//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_FORMULA_LIST = 'SET_FORMULA_LIST';
export const CLEAR_FORMULA_LIST = 'CLEAR_FORMULA_LIST';
export const FORMULA_LIST_PENDING = 'FORMULA_LIST_PENDING';
export const FORMULA_LIST_ERROR = 'FORMULA_LIST_ERROR';
export const FORMULA_LIST_ERROR_CLEAR = 'FORMULA_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const FORMULA_FILTER_DIALOG_OPEN = 'FORMULA_FILTER_DIALOG_OPEN';
export const FORMULA_FILTER_DIALOG_CLOSE = 'FORMULA_FILTER_DIALOG_CLOSE';
export const SET_FORMULA_FILTER_DATA = 'SET_FORMULA_FILTER_DATA';

//-----------------------------|| EXPORT ||-------------------------------------------------------------
export const FORMULA_EXPORT_PENDING = 'FORMULA_EXPORT_PENDING';
export const FORMULA_EXPORT_ERROR = 'FORMULA_EXPORT_ERROR';
export const FORMULA_EXPORT_ERROR_CLEAR = 'FORMULA_EXPORT_ERROR_CLEAR';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_FORMULA_DETAILS = 'SET_FORMULA_DETAILS';
export const CLEAR_FORMULA_DETAILS = 'CLEAR_FORMULA_DETAILS';
export const FORMULA_DETAIL_PENDING = 'FORMULA_DETAIL_PENDING';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const FORMULA_CREATE_DIALOG_OPEN = 'FORMULA_CREATE_DIALOG_OPEN';
export const FORMULA_CREATE_DIALOG_CLOSE = 'FORMULA_CREATE_DIALOG_CLOSE';
export const SET_FORM_FIELDS = 'SET_FORM_FIELDS';
export const CLEAR_FORM_FIELDS = 'CLEAR_FORM_FIELDS';
export const FORMULA_CREATE_PENDING = 'FORMULA_CREATE_PENDING';
export const FORMULA_CREATE_ERROR = 'FORMULA_CREATE_ERROR';
export const FORMULA_CREATE_ERROR_CLEAR = 'FORMULA_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const FORMULA_EDIT_DIALOG_OPEN = 'FORMULA_EDIT_DIALOG_OPEN';
export const FORMULA_EDIT_DIALOG_CLOSE = 'FORMULA_EDIT_DIALOG_CLOSE';
export const FORMULA_EDIT_PENDING = 'FORMULA_EDIT_PENDING';
export const FORMULA_EDIT_ERROR = 'FORMULA_EDIT_ERROR';
export const FORMULA_EDIT_ERROR_CLEAR = 'FORMULA_EDIT_ERROR_CLEAR';

//-----------------------------|| DELETE ||-------------------------------------------------------------
export const FORMULA_DELETE_CONFIRMATION_OPEN = 'FORMULA_DELETE_CONFIRMATION_OPEN';
export const FORMULA_DELETE_CONFIRMATION_CLOSE = 'FORMULA_DELETE_CONFIRMATION_CLOSE';
export const SET_FORMULA_DELETE_DATA = 'SET_FORMULA_DELETE_DATA';
export const FORMULA_DELETE_PENDING = 'FORMULA_DELETE_PENDING';
export const FORMULA_DELETE_ERROR = 'FORMULA_DELETE_ERROR';
export const FORMULA_DELETE_ERROR_CLEAR = 'FORMULA_DELETE_ERROR_CLEAR';


//-----------------------------|| OPTIONS ||------------------------------------------------------------
export const METRICS_OPTIONS = [
    { label: "Sum", value: "sum" },
    { label: "Average", value: "average" },
    { label: "Custom", value: "custom" },
]
export const METRICS_OPTIONS_NUMBER = [
    { label: "Sum", value: "sum" },
    { label: "Average", value: "average" },
    { label: "Custom", value: "custom" },
]
export const METRICS_OPTIONS_YESNO = [
    { label: "Average", value: "average" },
]

export const DATA_TYPE_OPTIONS = [
    { label: "Number", value: "int" },
    { label: "Present/Absent", value: "Yes/No" },
]
export const FORMULA_USAGE_FIELD_OPTIONS = [
    { label: "Yes", value: true },
    { label: "No", value: false },
]
